import { createI18n } from 'vue-i18n'
import de from './de'
import en from './en'
import fr from './fr'
import it from './it-new'

function getCurrLang() {
    const Arr = []
    if (window.pllLanguages !== undefined) {
        for (const key of Object.keys(window.pllLanguages)) {
            Arr.push(window.pllLanguages[key])
        }
    }

    return (
        Arr.find((lang) => {
            return lang.current_lang === true
        }) ?? { slug: 'de' }
    )
}

// this object contains all available keys, they are set via the translations window variable
const messages = { de, en, fr, it }

window.condaTranslations.en = window.condaTranslations.de
window.condaTranslations.fr = window.condaTranslations.de
window.condaTranslations.it = window.condaTranslations.de

const merge = (target, source) => {
    // loop through the source and assign the value to target if target does not have the key or if the value on target is empty
    for (const key of Object.keys(source)) {
        if (!target.hasOwnProperty(key) || (typeof target[key] === 'string' && target[key] === '')) {
            target[key] = source[key]
        }
        if (typeof source[key] === 'object') {
            // if both are objects, merge them
            target[key] = merge(target[key], source[key])
        }
    }
    return target
}

// read translations from wordpress
merge(messages, window.condaTranslations)

// 2. Create i18n instance with options
export const i18n = createI18n({
    legacy: false, // you must set `false`, to use Composition API
    locale: getCurrLang().slug, // set locale
    globalInjection: true,
    fallbackLocale: 'de', // set fallback locale
    messages, // set locale messages
    // If you need to specify other options, you can set other options
    // ...
})
